<template>
  <el-container class="demand">

    <el-header class="header-style">
      <el-divider content-position="left">用户提交需求</el-divider>
      <div class="el-col-4" style="margin-bottom: .2rem;">
        <el-input v-model="searchContent" placeholder="用户 / 手机号 / 来源 / 需求" size="mini" clearable></el-input>
      </div>
      <div style="display: inline-block; vertical-align: middle; margin-left: .2rem;">
        <el-button type="primary" @click="searchChange" size="mini">查询</el-button>
      </div>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 276px)" :data="demand" size="medium" border style="width: 100%">
        <el-table-column label='id' fixed>
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label='用户'>
          <template slot-scope="scope">
            {{ scope.row.user ? scope.row.name : '' }}
          </template>
        </el-table-column>
        <el-table-column label='会员手机号'>
          <template slot-scope="scope">
            <!-- <el-link style="color: #409EFF;cursor: pointer" @click="openPhoneFromDraw(scope.row.user.phone)">{{
          scope.row.user.phone }}</el-link> -->
            <div v-if="scope.row.user">
              <phone-com :comPhone="scope.row.user.phone" :vagaryPhone="scope.row.user.vagary_phone"
                style="display: inline-block" />
              <el-tooltip effect="drak" content="电话外呼" placement="right">
                <i @click="makePhone(scope.row.user.vagary_phone?scope.row.user.vagary_phone:scope.row.user.phone)" class="el-icon-phone-outline"
                  style="color: #409EFF;cursor:pointer;"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label='游客手机号'>
          <template slot-scope="scope">
            <!-- <el-link style="color: #409EFF;cursor: pointer" @click="openPhoneFromDraw(scope.row.demand_phone)">
              {{ scope.row.demand_phone }}
            </el-link> -->
            <div v-if="scope.row.demand_phone">
              <phone-com :comPhone="scope.row.demand_phone" :vagaryPhone="scope.row.vagary_phone"
                style="display: inline-block" />
              <el-tooltip effect="drak" content="电话外呼" placement="right">
                <i @click="makePhone(scope.row.vagary_phone?scope.row.vagary_phone:scope.row.demand_phone)" class="el-icon-phone-outline"
                  style="color: #409EFF;cursor:pointer;"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label='需求'>
          <template slot-scope="scope">
            {{ scope.row.demand }}
          </template>
        </el-table-column>
        <el-table-column label='来源'>
          <template slot-scope="scope">
            {{ scope.row.source }}
          </template>
        </el-table-column>
        <el-table-column label='创建时间' width="140">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination background layout="sizes, total, prev, pager, next, jumper" :hide-on-single-page="false"
        :current-page="pageOption.currentPage" :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageOption.pageSize"
        :total="pageOption.total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </el-footer>


    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import MakePhone from 'common/MakePhone'
import DateFormatter from 'common/DateFormatter'
import PhoneCom from "common/PhoneCom";
export default {
  name: 'Demand',
  components: { MakePhone, DateFormatter, PhoneCom },
  data() {
    return {
      phoneFrom_phone: [],
      phoneFromDraw: false,
      demand: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30
      },
      searchContent: ''
    }
  },
  computed: {
    // pageData: {
    //   get: function () {
    //     return this.demand.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
    //   }
    // },
    tableHeight: function () {
      return (window.innerHeight - 100) + 'px';
    },
    collapse() {
      return this.$store.state.collapse
    },
    maskedName() {
      return function (name) {
        const phoneNumberRegex = /\d{11}/g; // 匹配手机号的正则表达式
        if (phoneNumberRegex.test(name)) {
          return name.replace(phoneNumberRegex, (match) => {
            const replacement = match.substring(0, 3) + "****" + match.substring(7);
            return replacement;
          });
        }
        return name;
      };
    },
  },
  methods: {
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone)
      })
      this.phoneFromDraw = true
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }

      // this.$axios.post('/api/admin/call_logs/' + phone).then(res => {
      this.$axios.post('api/admin/call_logs_call', {
        phone
      }).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = []
      done()
    },
    getData() {
      this.$axios.get('/api/admin/UserDemand?page=' + this.pageOption.currentPage + '&page_size=' + this.pageOption.pageSize + '&keyword=' + this.searchContent)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.demand = data.data.data.data
            this.pageOption.pageSize = data.data.data.per_page
            this.pageOption.total = data.data.data.total
          }
        })
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val
      this.getData()
    },
    // 监听搜索事件
    searchChange() {
      this.pageOption.currentPage = 1
      this.getData()
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .el-dialog__wrapper >>> .el-drawer
    overflow-y: auto
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
  .addCon
    margin: .2rem 0
    text-align: right
  .el-row
    margin-bottom: .2rem
  .el-select
    width: 100%
  .avatar-uploader
    text-align: center
    margin-bottom: .2rem
  .avatar-uploader >>> .el-upload
    border: .02rem dashed #d9d9d9
    border-radius: .12rem
    cursor: pointer
    position: relative
    overflow: hidden
  .avatar-uploader >>> .el-upload:hover
    border-color: #409eff
  .avatar-uploader >>> .el-upload img
    width: 4rem
    height: 2rem
  .avatar-uploader-icon
    font-size: .4rem
    color: #8c939d
    width: 4rem
    height: 2rem
    line-height: 2rem
    text-align: center
  .demand
    marginLeft()
    max-height: 100vh
    .header-style
      height: 100px !important
      padding: 0px !important
    .main-style
      padding: 0px !important
      // overflow-y: auto
    .footer-style
      text-align: right
      .el-pagination
        padding-top: 25px
</style>



// WEBPACK FOOTER //
// src/pages/user/Demand.vue